import React from 'react'
import Header from '../../components/header/header.component'
import OverviewCard from '../../components/overview-cards/overview-card.component'
import "./home.styles.css"
import gamesJson from "../../games.json"

export default function Home() {
    return (
        <div>
            <Header></Header>
            <div className="grid">
                {
                    gamesJson.map((val, idx) => myExported(idx, val))
                }
            </div>
        </div>
    )
}

const myExported = (idx, val) => {
    if ((idx+1)%7 != 0) {
        return <OverviewCard url={`/${idx+1}`} imgUrl={val.thumbnailUrl} title={val.name} repackSize={val.tags['Repack Size']}/>
    }
    if ((idx+1)%7 == 0) {
        return <OverviewCard ad={`<iframe data-aa="1835599" src="//acceptable.a-ads.com/1835599" style="border:0px; padding:0; width:100%; height:100%; overflow:hidden; background-color: transparent;" ></iframe>`}/>
    }
}